<template>
  <teleport to="body">
    <app-registration
      :isOpenConnectAndPolygonModal="isBeginConnectionModalOpen"
    >
      <template v-slot:app-modal-body>
        <div class="app-modal-body-wrapper">
          <img src="@/Common/Icons/LOGO_GIF.gif" alt="Logo" class="logo-gif" />
          <div class="text-wrap">
            <p class="text-polygon">We use</p>
            <p class="text-polygon">Cardano</p>
            <p class="info-text">
              You will need to be connected to Cardano's Network.
            </p>
          </div>
          <div class="modal-buttons">
            <app-button
              @click="connect"
              text="Begin"
              buttonClass="app-modal-button-inverse-old"
            />
          </div>
          <a
            class="link-text"
            href="https://medium.com/theos-fi/theos-to-initially-deploy-on-polygon-then-ethereum-and-finally-cardano-429608cf76bf"
            target="_blank"
          >
            New to Cardano?
          </a>
        </div>
      </template>
    </app-registration>
  </teleport>
</template>
<script>
import { useStore } from "vuex";
import { ethereumService, cardanoService } from "../main";
import useAuth from "@/composables/useAuth";
import AppButton from "@/elements/AppButton";
import AppRegistration from "@/elements/AppRegistration";
import useMinting from "@/composables/useMinting";
export default {
  components: {
    AppRegistration,
    AppButton,
  },
  setup() {
    const store = useStore();
    const { loginOrSignUpCardano } = useAuth(
      store,
      ethereumService,
      cardanoService
    );
    const { isBeginConnectionModalOpen } = useMinting(store);
    const connect = () => {
      loginOrSignUpCardano();
      store.dispatch("minting/commitByKey", {
        isBeginConnectionModalOpen: false,
      });
    };
    return {
      isBeginConnectionModalOpen,
      loginOrSignUpCardano,
      connect,
    };
  },
};
</script>
<style
  lang="scss"
  scoped
  src="@/Common/Styles/connectionAndPolygonModal.scss"
></style>
